import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/articles';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Luxurious%20golden%20and%20warm%20coral%20abstract%20geometric%20pattern%20background%20with%20soft%20gradients%2C%20elegant%20minimalist%20design%2C%20premium%20lifestyle%20aesthetic%2C%20smooth%20flowing%20shapes%2C%20warm%20amber%20and%20cream%20tones%2C%20no%20text%20or%20objects%2C%20clean%20abstract%20backdrop&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
        alt="注册送彩金"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary-500/90 rounded-full mb-6">
          <i className="ri-flashlight-line text-background-50 w-4 h-4 flex items-center justify-center"></i>
          <span className="text-sm font-medium text-background-50 whitespace-nowrap">2026最新活动 · 限时进行中</span>
        </div>
        <h1 className="font-heading text-2xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight max-w-3xl">
          {siteInfo.tagline}
        </h1>
        <p className="text-sm md:text-base text-background-200 max-w-2xl mb-8 leading-relaxed">
          {siteInfo.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/category/platform-recommend"
            className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            立即查看平台推荐
            <i className="ri-arrow-right-line ml-2 w-4 h-4 inline-flex items-center justify-center align-middle"></i>
          </Link>
          <Link
            to="/category/bonus-guide"
            className="px-8 py-3 bg-background-50/15 text-background-50 font-medium rounded-lg border border-background-50/25 hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            查看领取攻略
          </Link>
        </div>
        <div className="mt-10 flex items-center gap-8">
          {[
            { value: '50万+', label: '服务用户' },
            { value: '200+', label: '合作平台' },
            { value: '98.6%', label: '好评率' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="font-heading text-xl md:text-2xl font-bold text-primary-400">{stat.value}</p>
              <p className="text-xs text-background-300 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}